import { createSlice } from "@reduxjs/toolkit";

const fixturesAndResultsSlice = createSlice({
  name: "fixturesAndResults",
  initialState: {
    loading: false,
    error: false,
    home: [],
    detail: [],
  },
  reducers: {
    updateLoadingStatus: (state, action) => {
      state.loading = action.payload;
    },
    updateErrStatus: (state) => {
      state.loading = false;
      state.error = true;
    },
    fetchHomeFixtures: (state, action) => {
      state.loading = false;
      state.error = false;
      state.home = action.payload;
    },
    fetchFixturesDetails: (state, action) => {
      state.loading = false;
      state.error = false;
      state.detail = action.payload;
    },
    
    updateFixtureAndResultHomeSocket: (state, action) => {
      const {
        awayteam,
        awayteam_goal,
        fixture_id,
        hometeam,
        hometeam_goal,
        league_id,
        match_id,
        result,
        status,
        updated_at,
        venue,
      } = action.payload;

      const oldHome = JSON.parse(JSON.stringify(state.home));
      let updatedHome = oldHome.map((ele) => {
        return {
          ...ele,
          fixtures: ele.fixtures.map((item) => {
            if (item?.fixture_id === fixture_id) {
              return {
                ...item,
                awayteam,
                awayteam_goal: awayteam_goal,
                hometeam,
                hometeam_goal: hometeam_goal,
                league_id,
                match_id,
                result,
                status,
                updated_at,
                venue,
              };
            }
            return item;
          }),
        };
      });
      state.home = updatedHome;
    },

    updateFixtureAndResultHomeDetails: (state, action) => {
      const {
        awayteam_goal,
        fixture_id,
        hometeam_goal,
        status
      } = action.payload;
      const oldDetail = JSON.parse(JSON.stringify(state.detail));

      let updatedDetail = oldDetail.map((ele) => {
        if (ele?.date === new Date().toISOString().split("T")[0]) {
          return {
            ...ele,
            fixtures: ele.fixtures.map((item) => {
              if (item?.fixture_id === fixture_id) {
                return {
                  ...item,
                  awayteam_goal: awayteam_goal,
                  hometeam_goal: hometeam_goal,
                  status: status,
                };
              }
              return item;
            }),
          };
        }
        return ele;
      });
      state.detail = updatedDetail;
    },
  },
});

export const {
  updateLoadingStatus,
  updateErrStatus,
  fetchHomeFixtures,
  fetchFixturesDetails,
  updateFixtureAndResultHomeSocket,
  updateFixtureAndResultHomeDetails,
} = fixturesAndResultsSlice.actions;

export default fixturesAndResultsSlice.reducer;
